import React from 'react';
import { Box, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { useTheme } from '../ThemeContext';

interface MobileHeaderProps {
  title: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ title }) => {
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const { theme } = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        height: isMobile ? '80px' : '200px',
        background: isMobile ? theme.colors.headerGradient : '#D3D3D3', // Changed background to gradient for mobile
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: isMobile ? 0 : 4,
      }}
    >
      <Box
        sx={{
          width: '90%',
          maxWidth: '400px',
          height: isMobile ? '60px' : '120px',
          backgroundColor: theme.colors.whiteCardBackground,
          borderRadius: '16px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: isMobile ? '50px' : '120px',
          zIndex: 1,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.colors.darkText, whiteSpace: 'normal' }}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default MobileHeader;
